import { createFileRoute } from "@tanstack/react-router";
import { OmPage } from "./om";

export const Route = createFileRoute("/es/sobre-nosotros")({
  head: () => ({
    meta: [
      { title: "Sobre Sellavo – haz una foto o un vídeo, nosotros escribimos el anuncio" },
      { name: "description", content: "Sellavo convierte tus fotos o tu vídeo en un anuncio listo con título, texto y precio." },
      { property: "og:title", content: "Sobre Sellavo – haz una foto o un vídeo, nosotros escribimos el anuncio" },
      { property: "og:description", content: "Sellavo convierte tus fotos o tu vídeo en un anuncio listo con título, texto y precio." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/sobre-nosotros" }],
  }),
  component: OmPage,
});
